<template>
    <path fill-rule="evenodd" d="M18.272 14.302L4.424.812C3.904.303 3.174 0 2.551 0 1.927 0 1.3.304.78.811-.26 1.825-.26 3.246.78 4.26l12.077 11.765L.78 27.791C-.26 28.805-.26 30.225.78 31.24c1.04 1.015 2.603 1.015 3.643 0l13.848-13.49c.52-.507.728-1.116.728-1.725 0-.71-.208-1.217-.728-1.724v.002z"/>
</template>

<script>
export default {
    name: 'arrowRightIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 19 32');
    }
};
</script>
